import store from '@/store'

export default {
    hasTeamEditRights(appPageId) {
        if (!store.state.selectedTeamPermissions) return false
        const permission = store.state.selectedTeamPermissions
                    .find(p => p.appPageId === appPageId)
        return permission && permission.edit
    },
    hasTeamApproverRights(appPageId) {
        if (!store.state.selectedTeamPermissions) return false
        const permission = store.state.selectedTeamPermissions
                    .find(p => p.appPageId === appPageId)
        return permission && permission.approver
    }
}